import React from 'react'
import {UniLink, TertiaryButtonDark, SecondaryButton} from '../../../../core/components/unilink/index'
import {TextInput} from '../../../../core/components/input/index'
import validateDisplayName from '../../../../core/components/utilities/ValidateDisplayName.js'
import validateEmail from '../../../../core/components/utilities/ValidateEmail.js'
import DefaultUserPicture from '../../../../core/components/default-user-picture/DefaultUserPicture'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class AccountSettings extends React.PureComponent {
  constructor(props) {
    super(props)
    const {user} = this.props
    this.state = {
      email: user.email,
      imagePreview: user.profilePicture,
      imageFile: null,
      displayName: user.displayName,
      isDirty: false,
      accountChangeResults: {
        success: false,
        message: ''
      }
    }

    this.imageChange = this.imageChange.bind(this)
    this.removeImage = this.removeImage.bind(this)
    this.nameChange = this.nameChange.bind(this)
    this.emailChange = this.emailChange.bind(this)
    this.submitChanges = this.submitChanges.bind(this)
  }
  imageChange(e) {
    if (e.target.files.length) {
      const file = e.target.files[0]
      this.setState({
        imagePreview: window.URL.createObjectURL(file),
        imageFile: file,
        isDirty: true,
        accountChangeResults: {
          success: false,
          message: ''
        }
      })
    }
  }
  removeImage() {
    const {displayName, profilePicture} = this.props.user
    this.setState({
      imagePreview: null,
      imageFile: null,
      isDirty: this.state.displayName !== displayName || profilePicture !== null,
      accountChangeResults: {
        success: false,
        message: ''
      }
    })
  }
  nameChange(e) {
    const {displayName, profilePicture} = this.props.user
    this.setState({
      displayName: e.target.value.trim(),
      isDirty: e.target.value.trim() !== displayName || profilePicture !== this.state.imagePreview,
      accountChangeResults: {
        success: false,
        message: ''
      }
    })
  }

  emailChange(e) {
    const {email} = this.props.user
    this.setState({
      email: e.target.value.trim(),
      isDirty: e.target.value.trim() !== email,
      accountChangeResults: {
        success: false,
        message: ''
      }
    })
  }
  submitChanges() {
    const {displayName, imageFile, imagePreview, email} = this.state
    const {putSaveAccountChanges} = this.props
    putSaveAccountChanges(displayName, imageFile, imagePreview, email)
      .then(()=>{
        this.setState({
          isDirty: false,
          accountChangeResults: {
            success: true,
            message: 'Changes Saved'
          }
        })
      })
      .catch((e)=> {
        this.setState({
          isDirty: false,
          accountChangeResults: {
            success: false,
            message: 'Error Saving Changes'
          }
        })
      })
  }

  render() {
    const {imageFile, imagePreview, displayName, accountChangeResults, email} = this.state
    const accountChangeState = accountChangeResults.success ? 'success' : 'fail'
    return (
      <div className='edit-profile__content'>
        <div className='account-settings'>
          <div className='edit-profile__block'>
            <h1 className='edit-profile__block-title'>Account Info</h1>
            <div className='edit-profile__block'>
              <div className='edit-profile__detail'>
                User ID: <strong>{this.props.user.id}</strong>
              </div>
              <div className='edit-profile__input-container'>
                <label
                  className='edit-profile__label'
                  htmlFor='displayname'>Display Name:</label>
                <TextInput
                  className='edit-profile__text-input'
                  defaultValue={displayName}
                  onChange={this.nameChange}
                  id='displayname' />
              </div>
              <div className='edit-profile__input-container'>
                <label
                  className='edit-profile__label'
                  htmlFor='email'>Email:</label>
                <TextInput
                  className='edit-profile__text-input'
                  defaultValue={email}
                  onChange={this.emailChange}
                  id='email' />
              </div>

            </div>
          </div>
          <div className='edit-profile__block'>
            <div className='edit-profile__detail'>
              Profile Picture:
            </div>
            <div className='edit-profile__change-picture'>
              
              {
                imagePreview
                  ? <UniLink
                    onClick={ this.removeImage }
                    key='2'
                    className='edit-profile__remove-profile-picture'>
                    <FontAwesomeIcon icon={['fa', 'times']} />
                  </UniLink>
                  : null
              }
              { 
                imageFile ? <img src={ imagePreview } alt='' className='edit-profile__profile-picture'/>
                :
              <DefaultUserPicture
                displayName={ displayName }
                profilePicture={ imagePreview }
                className='edit-profile__profile-picture' /> 
            }
              <label htmlFor='imageupload'>
                <TertiaryButtonDark className='edit-profile__button'>
                  Upload
                </TertiaryButtonDark>
              </label>
              <input
                type='file'
                id='imageupload'
                name='imageupload'
                accept='.jpg, .jpeg, .png'
                onChange={ this.imageChange }
              />
            </div>
            <div className='edit-profile__submit'>
              <SecondaryButton
                disabled={!(this.state.isDirty 
                  && this.state.displayName.trim() 
                  && this.state.email.trim() 
                  && validateDisplayName(this.state.displayName)
                  && validateEmail(this.state.email)
                  )}
                onClick={this.submitChanges}
                className='edit-profile__button'>
                Save Changes
              </SecondaryButton>
              {
                accountChangeResults.message.length
                  ? <span className={`edit-profile__result edit-profile__result--${accountChangeState}`}>
                    {accountChangeResults.message}
                  </span>
                  : null
              }
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default AccountSettings



// WEBPACK FOOTER //
// ./src/domains/user/edit-profile/components/AccountSettings.js